<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 41 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_805_2221" height="40" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="41" x="0" y="0">
      <circle cx="20.75" cy="20" :fill="fill" r="19.0476" :stroke="fill" stroke-width="1.90476"/>
    </mask>
    <g mask="url(#mask0_805_2221)">
      <circle cx="20.75" cy="20" r="18.5" :stroke="fill" stroke-width="3"/>
    </g>
    <mask id="mask1_805_2221" height="30" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="31" x="5" y="5">
      <circle cx="20.75" cy="20" :fill="fill" r="14" :stroke="fill" stroke-width="2"/>
    </mask>
    <g mask="url(#mask1_805_2221)">
      <circle cx="20.75" cy="20" r="14" :stroke="fill" stroke-width="2"/>
    </g>
    <path d="M19.75 12C19.75 11.4477 20.1977 11 20.75 11C21.3023 11 21.75 11.4477 21.75 12V21H19.75V12Z" :fill="fill"/>
    <path d="M25.9465 22.2676C26.4248 22.5437 26.5886 23.1553 26.3125 23.6336C26.0364 24.1119 25.4248 24.2758 24.9465 23.9996L19.7503 20.9996L20.7503 19.2676L25.9465 22.2676Z" :fill="fill"/>
  </svg>

</template>

<script>
export default {
  name: 'Clock',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
